// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"478":"31d6cfe0","515":"8075b026","729":"8075b026","748":"f2ee3c5d","760":"0bfe1412"}[chunkId] + ".chunk.css";
};